import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { getOpenPagesRoutes } from 'common/constants/routes';
import { useComplianceStore } from 'common/services/compliance-service/service-store/service-store';
import { useProfileStore } from 'common/services/profile-service/service-store/service-store';
import { profileServiceIsAgreeWithUsagePoliciesSelector } from 'common/services/profile-service/service-store/selectors';
import { complianceServiceShouldShowPageSelector } from 'common/services/compliance-service/service-store/selectors';
var OPEN_PAGES_PATHS = getOpenPagesRoutes().map(function (el) { return "/".concat(el.path); });
var COMPLIANCE_PAGE_PATH = '/compliance';
var isPolicyConsentExemptPath = function (pathname) {
    return pathname === COMPLIANCE_PAGE_PATH || OPEN_PAGES_PATHS.includes(pathname);
};
export var RequiredPolicyConsent = function () {
    var location = useLocation();
    var isComplianceDocumentExist = useComplianceStore(complianceServiceShouldShowPageSelector);
    var isAgreeWithUsagePolicies = useProfileStore(profileServiceIsAgreeWithUsagePoliciesSelector);
    if (!isPolicyConsentExemptPath(location.pathname) && isComplianceDocumentExist && !isAgreeWithUsagePolicies) {
        return _jsx(Navigate, { replace: true, to: COMPLIANCE_PAGE_PATH, state: { from: location.pathname } });
    }
    return _jsx(Outlet, {});
};
